import React from 'react';
import { Shield } from 'lucide-react';
export function Garantia() {
  return <section className="bg-white text-lsa-dark py-16 px-5" data-id="element-101">
      <div className="max-w-md mx-auto text-center" data-id="element-102">
        <div className="flex justify-center mb-6" data-id="element-103">
          <div className="w-20 h-20 bg-lsa-light rounded-full flex items-center justify-center text-lsa-celeste" data-id="element-104">
            <Shield size={40} strokeWidth={1.5} data-id="element-105" />
          </div>
        </div>

        <h2 className="text-[24px] font-bold mb-4" data-id="element-106">
          Garantía 7 días — Sin preguntas
        </h2>

        <p className="text-[15px] text-lsa-dark/80 leading-relaxed mb-6" data-id="element-107">
          Abrís el sistema. Lo usás. Si en 7 días no es lo que esperabas, te
          devolvemos el 100% sin formularios, sin drama.
        </p>

        <div className="inline-block bg-green-50 border border-green-200 text-green-700 px-4 py-1.5 rounded-full text-[13px] font-bold tracking-wide" data-id="element-108">
          Tasa de devoluciones: menos del 1%.
        </div>
      </div>
    </section>;
}